"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserUploadButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const disperse_json_1 = __importDefault(require("@framework/abis/json/Dispenser/disperse.json"));
const dialogs_1 = require("../../../../dialogs");
const utils_1 = require("./utils");
const dialog_1 = require("./dialog");
const initialValues = {
    rows: [],
};
const DispenserUploadButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const metaFnWithContract = (0, react_hooks_eth_1.useSystemContract)(async (values, systemContract) => {
        const { rows } = values;
        const [items, receivers] = rows.reduce(([items, receivers], { account, ...rest }) => {
            receivers.push(account);
            items.push(rest);
            return [items, receivers];
        }, [[], []]);
        const assets = items.map(item => {
            return {
                tokenType: Object.values(types_1.TokenType).indexOf(item.tokenType).toString(),
                token: item.address,
                tokenId: item.tokenId,
                amount: BigInt(item.amount),
            };
        });
        return writeContractAsync({
            address: systemContract.address,
            abi: disperse_json_1.default,
            functionName: "disperse",
            args: [
                assets,
                receivers,
                {
                    value: (0, utils_1.getEthPrice)(assets),
                },
            ],
        });
    });
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)((values) => {
        return metaFnWithContract(types_1.SystemModuleType.DISPENSER, values);
    });
    const handleUploadConfirm = async ({ data }) => {
        await metaFn(data);
    };
    const handleUpload = () => {
        openDialog(dialogs_1.GlobalDialogKeys.DISPENSER_UPLOAD, initialValues, {
            initialValues,
            message: "dialogs.upload",
            testId: "ClaimUploadDialog",
            validationSchema: dialog_1.dispenserUploadValidationSchema,
            onExternalConfirm: handleUploadConfirm,
            componentProps: {
                initialValues,
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Add, message: "form.buttons.upload", className: className, dataTestId: "DispenserUploadButton", disabled: disabled, variant: variant }));
};
exports.DispenserUploadButton = DispenserUploadButton;
//# sourceMappingURL=index.js.map